import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService, } from '../services/request-management.service';
import { UserService } from '../services/user.service';
import 'rxjs/add/operator/map';
import { TermModel } from '../_models/_index';

@Injectable()
export class TermService {

    constructor(private requestManagement: RequestManagementService,
        private userService: UserService) { }

    public getTerms(): Promise<TermModel[]> {
        return this.requestManagement.callGetRequest('terms/get', { 'userId': this.userService.getCurrentUser().id }).map((response: Response) => {
            return <TermModel[]>response.json();
        }).toPromise();
    }

    public addTerm(model: TermModel): Promise<TermModel> {
        model.creatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('terms/add', model).map((response: Response) => {
            return <TermModel>response.json();
        }).toPromise();
    }

    public editTerm(model: TermModel): Promise<TermModel> {
        model.updatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('terms/edit', model).map((response: Response) => {
            return <TermModel>response.json();
        }).toPromise();
    }

    public removeTerm(model: TermModel): Promise<TermModel> {
        model.updatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('terms/remove', model).map((response: Response) => {
            return <TermModel>response.json();
        }).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/term.service.ts